var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "column is-offset-1 is-10" },
    [
      _vm.fetchingContributor || _vm.fetchingContributions
        ? [
            _c(
              "div",
              { staticClass: "content-loader" },
              [
                _c(
                  "ContentLoader",
                  {
                    staticClass: "mb-3",
                    attrs: {
                      height: 72,
                      width: 1076,
                      speed: 2,
                      primaryColor: "#f3f3f3",
                      secondaryColor: "#ecebeb"
                    }
                  },
                  [
                    _c("rect", {
                      attrs: {
                        x: "16",
                        y: "0",
                        rx: "0",
                        ry: "0",
                        width: "200",
                        height: "72"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ContentLoader",
                  {
                    staticClass: "mb-2",
                    attrs: {
                      height: 640,
                      width: 1076,
                      speed: 2,
                      primaryColor: "#f3f3f3",
                      secondaryColor: "#ecebeb"
                    }
                  },
                  [
                    _c("rect", {
                      attrs: {
                        x: "16",
                        y: "0",
                        rx: "0",
                        ry: "0",
                        width: "1060",
                        height: "200"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "16",
                        y: "220",
                        rx: "0",
                        ry: "0",
                        width: "1060",
                        height: "180"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "16",
                        y: "420",
                        rx: "0",
                        ry: "0",
                        width: "1060",
                        height: "200"
                      }
                    })
                  ]
                )
              ],
              1
            )
          ]
        : [
            _vm.contributor
              ? _c(
                  "div",
                  { staticClass: "d-flex mb-5" },
                  [
                    _vm.contributor.name
                      ? [
                          _c(
                            "div",
                            { staticClass: "avatar mr-3 d-none d-sm-block" },
                            [
                              _c("span", { staticClass: "avatar__initials" }, [
                                _vm._v(_vm._s(_vm.contributor.initials))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {}, [
                            _c("h1", [_vm._v(_vm._s(_vm.contributor.name))]),
                            _vm._v(" "),
                            _vm.contributions
                              ? _c("h5", { staticClass: "t-dark-grey" }, [
                                  _vm._v(
                                    _vm._s(_vm.contributions.total) +
                                      " Contributions"
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]
                      : [_c("h1", [_vm._v("Contributor doesn't exist")])]
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.contributions.data, function(contribution) {
              return _c(
                "div",
                { staticClass: "card p-2 p-lg-7 mb-3" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-block d-sm-flex justify-content-between align-items-center mb-3"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "card__hazard-meta mb-2 mb-sm-0" },
                        [
                          _c("h2", { staticClass: "t-orange" }, [
                            _vm._v(_vm._s(contribution.hazard.name))
                          ]),
                          _vm._v(" "),
                          _c("h5", { staticClass: "t-navy" }, [
                            _vm._v(_vm._s(contribution.hazard.type.name))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn",
                          attrs: { href: contribution.hazard.url }
                        },
                        [_vm._v("Visit UXO")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "contribution__meta fs-12 font-weight-light t-navy lh-sm mb-2"
                    },
                    [
                      _vm._v(
                        "Contributed on\n                " +
                          _vm._s(_vm.formattedDate(contribution.created_at)) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "contribution__content font-weight-light lh-lg"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(contribution.contribution_text) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.getLinks(contribution.contribution_text)
                    ? _c(
                        "div",
                        { staticClass: "social-card-wrapper mt-6" },
                        _vm._l(
                          _vm.getLinks(contribution.contribution_text),
                          function(link, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "social-card-container"
                              },
                              [
                                _c("link-prevue", {
                                  attrs: {
                                    apiUrl: _vm.$root.linkPrevueApiUrl,
                                    url: link.href
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(props) {
                                          return [
                                            props.img ||
                                            props.title ||
                                            props.description
                                              ? _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      target: "_blank",
                                                      href: props.url
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "social-card"
                                                      },
                                                      [
                                                        props.img
                                                          ? _c("div", {
                                                              staticClass:
                                                                "social-card__image",
                                                              style:
                                                                "background-image: url('" +
                                                                props.img +
                                                                "')"
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "social-card__content"
                                                          },
                                                          [
                                                            props.title
                                                              ? _c(
                                                                  "h4",
                                                                  {
                                                                    staticClass:
                                                                      "social-card__content-title"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                            " +
                                                                        _vm._s(
                                                                          props.title
                                                                        )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            props.description
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "social-card__content-body"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                            " +
                                                                        _vm._s(
                                                                          props.description
                                                                        )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _c("div")
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  contribution.files.length
                    ? _c("cat-uxo-thumbnail-gallery", {
                        staticClass: "d-flex mt-3",
                        attrs: { files: contribution.files }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  contribution.files.length
                    ? _c("cat-uxo-file-list", {
                        staticClass: "rows mt-3",
                        attrs: { files: contribution.files }
                      })
                    : _vm._e()
                ],
                1
              )
            })
          ],
      _vm._v(" "),
      _vm.contributions.last_page > 1
        ? [
            _c("paginate", {
              attrs: {
                "page-count": _vm.contributions.last_page,
                "prev-text": "&nbsp;",
                "next-text": "&nbsp;",
                "prev-link-class": "pagination-previous",
                "next-link-class": "pagination-next",
                "container-class": "pagination-list",
                "page-class": "pagination-item",
                "page-link-class": "pagination-link",
                "click-handler": _vm.paginate
              }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36a79816", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36a79816","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/Supporter.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-36a79816","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/Supporter.vue
// module chunks = 0 1